'use strict';
import angular from 'angular';
var CredentialAddController = /** @class */ (function () {
    /*@ngInject*/
    function CredentialAddController(Auth, $state, $log, $cookies, $scope, $timeout, Util, CredentialAddService, Upload) {
        this.credentialType = null;
        this.credentialTypes = ['License', 'Other'];
        this.selectedCredentialType = null;
        this.selectedDoctorType = null;
        this.selectedCredential = null;
        this.files = null;
        this.file = null;
        this.log = null;
        this.progressPercentage = 0;
        this.prevCredential = null;
        this.showAlert = false;
        this.loadingBar = false;
        this.closeAlertMessage = function () {
            this.showAlert = false;
        };
        this.$log = $log;
        this.$scope = $scope;
        this.Upload = Upload;
        this.$cookies = $cookies;
        this.$timeout = $timeout;
        this.credentialAddService = CredentialAddService;
        this.Util = Util;
        var self = this;
        if (self.mode != 'Edit') {
            self.credentialAddService.getDoctorTypes().then(function (response) {
                if (response.status == 200 && response.data.errors.length == 0) {
                    self.doctorTypes = response.data.response.currentPage;
                }
            });
            self.credential = {
                id: 1,
                credentialType: null,
                doctorType: null,
                file: null,
                status: null
            };
        }
        else {
            if (self.credential.credentialType == null) {
                self.credential.credentialType = 'Other';
            }
            self.selectedCredentialType = self.credential.credentialType;
            self.selectedCredential = self.credential;
            self.credentialAddService.getDoctorTypes().then(function (response) {
                if (response.status == 200 && response.data.errors.length == 0) {
                    self.doctorTypes = response.data.response.currentPage;
                    self.selectedDoctorType = self.getDoctorType(self.credential.doctorType);
                }
            });
        }
        //$scope.$watch('cda.files', function() {
        // self.upload(self.selectedCredential);
        //});
        $scope.$watch('cda.credAddForm.cdaFile.$error.pattern', function () {
            if (self.credAddForm.cdaFile.$error.pattern) {
                self.showAlert = true;
                self.Util.setPageErrors('Please use one of our accepted file types: jpg, png, pdf, or gif. File size limit 1MB.', '', self);
            }
        });
        $scope.$watch('cda.file', function (newVal, oldVal) {
            if (newVal == oldVal)
                return;
            if (self.file != null) {
                self.showAlert = false;
                if (self.file.size) {
                    if (self.file.size > 1000000) {
                        self.showAlert = true;
                        self.Util.setPageErrors('Please use one of our accepted file types: jpg, png, pdf, or gif. File size limit 1MB.', '', self);
                        $scope.$emit('credentialAddFormValid', false);
                    }
                    if (self.selectedDoctorType != null && self.file.size <= 1000000) {
                        $scope.$emit('credentialAddFormValid', true);
                        //self.files = [self.file];
                    }
                }
                else {
                    self.Util.setPageErrors('Cannot upload empty file', '', self);
                    self.showAlert = true;
                }
            }
        });
        self.log = '';
        $scope.$watch('$viewContentLoaded', function (event) {
            $scope.$watch('cda.credAddForm.$valid', function (newVal, oldVal) {
                console.log('form valid ->', newVal);
                if (newVal !== oldVal) {
                    console.log('form valid 2 ->', newVal);
                    if (self.file && self.file.size <= 1000000) {
                        console.log('In credential Add Form Valid Watch  Emitting event  with newVal-> ' + newVal);
                        $scope.$emit('credentialAddFormValid', newVal);
                    }
                }
            });
        });
        // Listening to the event from submit button in parent (container) template
        $scope.$on('submitForm', function (event, data) {
            self.setCredentialBeforeAdd();
            self.onUpdate({
                $event: {
                    credential: self.credential
                }
            });
            self.resetFormFields();
        });
        $scope.$on('AddCredentialError', function (event, data) {
            self.loadingBar = false;
            self.Util.handleApiError(data, self);
            self.restoreFormFields();
        });
        $scope.$on('AddCredentialStarted', function (event, data) {
            self.loadingBar = true;
        });
        $scope.$on('AddCredentialFinished', function (event, data) {
            self.loadingBar = false;
            self.Util.resetApiError(self);
        });
    }
    CredentialAddController.prototype.resetFormFields = function () {
        var self = this;
        self.prevCredential = angular.copy(self.credential);
        self.credential = null;
        self.file = null;
        if (self.credAddForm) {
            self.credAddForm.$setPristine();
            self.credAddForm.$setUntouched();
        }
    };
    CredentialAddController.prototype.restoreFormFields = function () {
        var self = this;
        self.credential = angular.copy(self.prevCredential);
        self.prevCredential = null;
    };
    CredentialAddController.prototype.setCredentialBeforeAdd = function () {
        var self = this;
        if (self.file) {
            console.log('Before sending file ->', self.file);
            self.credential.status = 'Upload Pending';
            self.credential.file = self.file;
        }
        self.credential.doctorType = self.selectedDoctorType;
        self.credential.credentialType = self.selectedCredentialType;
    };
    CredentialAddController.prototype.getDoctorType = function (doctorDescription) {
        for (var i = 0; i < this.doctorTypes.length; i++) {
            if (this.doctorTypes[i].description == doctorDescription) {
                return this.doctorTypes[i];
            }
        }
    };
    CredentialAddController.prototype.changeCredType = function (credType, credential) {
        var self = this;
        self.selectedCredentialType = credType;
    };
    CredentialAddController.prototype.changeDoctorType = function (doctorType, credential) {
        var self = this;
        self.selectedDoctorType = doctorType;
        if (self.file != null) {
            self.$scope.$emit('credentialAddFormValid', true);
        }
    };
    CredentialAddController.prototype.addCredential = function () {
        this.credential = {
            id: this.credential.length + 1,
            credentialType: null,
            fileName: null,
            status: null
        };
    };
    CredentialAddController.prototype.$onDestroy = function () {
        console.log('in $onDestroy.....');
    };
    CredentialAddController.prototype.$postLink = function () {
        console.log('in $postLink.....');
    };
    CredentialAddController.prototype.$onInit = function () {
        console.log('in $onInit.....');
    };
    // This is to ensure that any changes to our local user object don't reflect in
    // the parent object that was passed to us.
    CredentialAddController.prototype.$onChanges = function (changes) {
        console.log('$onChanges ->', changes);
        if (changes.credential) {
            this.credential = angular.copy(this.credential);
        }
    };
    return CredentialAddController;
}());
export default CredentialAddController;
//# sourceMappingURL=credential-add.controller.js.map